import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { rotate } from '@/styles/animations';

export const StyledPremiumBanner = styled.div`
  border-top: 1px solid var(--border-color);
  ${'' /* background-color: var(--muted); */}
  padding: 6rem 4rem;
  padding-bottom: 4rem;
  display: grid;
  ${'' /* grid-template-rows: 1fr 6fr 3fr; */}
  align-items: center;
  grid-gap: 1rem;
  place-content: center;
  text-align: center;
  h1 {
    font-size: 5.5rem;
    line-height: 5rem;
    margin: 0;
    padding-bottom: 2rem;
    font-weight: 800;
    letter-spacing: 2px;
    /* Fallback: Set a background color. */
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .lead {
    font-size: 2rem;
    line-height: 2.5rem;
    ${'' /* color: var(--muted-strong); */}
    opacity: 0.9;
    font-weight: 500;
    padding-bottom: 0.5rem;
  }
  .gradient-primary {
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
  }
  .gradient-text {
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xxl}) {
    h1 {
      font-size: 5.5rem;
      line-height: 5rem;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xl}) {
    grid-template-columns: 1fr;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }
    padding-top: 4rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    padding: 3rem 3rem;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }

    h1 {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.5rem 2rem;
    h1 {
      font-size: 4rem;
      line-height: 3.5rem;
      text-align: center;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }
  }
`;

export const FeatureListWrapper = styled.div`
  margin-top: -3rem;
  padding-bottom: 4rem;
`;

export const StyledContentBanner = styled.div`
  ${'' /* margin-top: -2rem; */}
  padding: 4rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  align-items: center;
  position: relative;
  .content-col {
    padding: 0 4rem;
    h2 {
      font-size: 2.5rem;
      margin: 0;
    }
    p,
    ul,
    ol {
      font-size: 1.175rem;
      line-height: 2rem;
      word-break: break-word;
    }
  }
  .img-col {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 4rem 2rem;
    perspective: 1000px;
    &::before {
      position: absolute;
      content: '';
      background-color: var(--indigo);
      background-image: linear-gradient(45deg, var(--blue), var(--indigo));
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 1rem;
      z-index: -2;
      transition: 0.2s all ease-in-out;
      ${'' /* transform: rotateY(20deg) rotateX(-1deg); */}
      box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.blue, 0.25)};
    }
    &.right {
      &::before {
        ${'' /* transform: rotateY(-20deg) rotateX(-1deg); */}
      }
    }
    &.pink-yellow {
      &::before {
        background-color: var(--yellow);
        background-image: linear-gradient(45deg, var(--pink-hover), var(--yellow));
        box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.pink, 0.25)};
      }
    }
    &.pink-red {
      &::before {
        background-color: var(--pink);
        background-image: linear-gradient(45deg, var(--pink), var(--red));
        box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.pink, 0.25)};
      }
    }
    &.teal-green {
      &::before {
        background-color: var(--green);
        background-image: linear-gradient(45deg, var(--teal), var(--green));
        box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.green, 0.25)};
      }
    }
    &.muted {
      &::before {
        background-color: var(--muted-strong);
        background-image: linear-gradient(45deg, var(--muted-strong), var(--grey));
        box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.mutedStrong, 0.25)};
      }
    }
    &.orange {
      &::before {
        background-color: var(--orange);
        background-image: linear-gradient(45deg, var(--orange), var(--orange-hover));
        box-shadow: 0px 3px 20px 5px ${({ theme }) => rgba(theme.colors.orange, 0.25)};
      }
    }
    ${'' /* &:hover {
      &::before {
        transform: rotateY(0) rotateX(0);
      }
    } */}
    .img-wrapper {
      width: 400px;
      height: 400px;
      position: relative;
      img {
        object-fit: contain;
      }
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.lg}) {
    grid-template-columns: 1fr;
    .content-col {
      padding: 0 2rem;
      padding-bottom: 1rem;
      order: 1;
    }
    .img-col {
      .img-wrapper {
        width: 250px;
        height: 250px;
      }
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    .img-col {
      .img-wrapper {
        width: 250px;
        height: 250px;
      }
    }
  }
`;

export const StyledPricingBlock = styled.div`
  padding: 2rem 0;
  ${'' /* display: grid; */}
  align-items: center;
  ${'' /* grid-gap: 1rem; */}
  ${'' /* place-content: center; */}
  text-align: center;
  h2 {
    font-size: 5.5rem;
    line-height: 5rem;
    margin: 0;
    padding-bottom: 2rem;
    font-weight: 800;
    letter-spacing: 2px;
    /* Fallback: Set a background color. */
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .lead {
    font-size: 2rem;
    line-height: 2.5rem;
    ${'' /* color: var(--muted-strong); */}
    opacity: 0.9;
    font-weight: 500;
    padding-bottom: 0.5rem;
  }
  .gradient-primary {
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
  }
  .gradient-text {
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xxl}) {
    h2 {
      font-size: 5.5rem;
      line-height: 5rem;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xl}) {
    grid-template-columns: 1fr;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }
    padding-top: 4rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    padding: 3rem 3rem;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }

    h2 {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.5rem 2rem;
    h2 {
      font-size: 4rem;
      line-height: 3.5rem;
      text-align: center;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }
  }
`;
